import {useIsPermittedByRole} from 'common/hooks/useIsPermittedByRole';
import React from 'react';
import {useDispatch} from 'react-redux';
import {AdminResourceType} from 'types/diplomat/settings/adminroles/AdminResourceType';
import {settingsActions} from '..';

export const useFetchAuditSettings = () => {
   const dispatch = useDispatch();
   const isPermittedByRole = useIsPermittedByRole();

   React.useEffect(() => {
      if (isPermittedByRole(AdminResourceType.enum.SETTINGS)) {
         dispatch(settingsActions.getAuditTrailSettings());
      }
   }, [dispatch, isPermittedByRole]);
};
